/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Params, Router, ActivatedRoute} from '@angular/router';
import {LdapServiceService} from "../../../services/ldap-service.service";
import {RemoteService} from "../../../services/driver-data-table-remote-service";
import {Driver} from "../../../model/Driver";
import {DriverService} from "../../../services/driver.service";
// import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {NgxSpinnerService} from 'ngx-spinner';
import {GmPerson} from "../../../model/GmPerson";
import {GmPersonService} from "../../../services/gm-person.service";
import {MsgraphServiceService} from '../../../services/msgraph-service.service';
declare var $:any;

@Component({
    selector: 'driver-editable-table',
    providers: [MsgraphServiceService, RemoteService],
    templateUrl: './driver-editable-table.html',
    standalone: false
})

export class DriverEditableTable implements OnInit{
  itemCount;
  items = [];
  exitingItems=[];
  router= Router;
  LDAPSearchDone=false;
  secondTableTitle ="Existing Drivers";
  needFullPage=true;


  constructor(private ldapService: MsgraphServiceService, private remoteService: RemoteService,
              private driverService: DriverService, private route: ActivatedRoute, private gmPersonService: GmPersonService,
              private spinnerService: NgxSpinnerService, private cdr: ChangeDetectorRef) {  }

  @Input() searchFor: string;

  @Output() reloadItem = new EventEmitter();

  ngOnInit(){
    this.route.queryParams.subscribe((params: Params)=>{
      if(params['modalpopup']!=undefined){
        this.needFullPage=false;
        this.secondTableTitle = "Existing Person(s)"
      }
      else
        this.needFullPage=true;
    });
  }

  cellColor(item){
     if (this.exitingItems!=undefined){
      if (this.exitingItems.find(x=>x.identificationId==item.gmIn)){
        return 'rgb(255,255,122)';
      }
     }
  }

  reloadItems(params,name? : string) {
    //this.loading = true;
    if (this.searchFor!=undefined && this.searchFor.length>0)
      name=this.searchFor;
    if (name == undefined || name.length == 0) {
    }
    else {
      this.doSearch(name);
    }
    //this.localParams = params;

  }

  OpenModal(){
    //window.location.href='personDetail/?modalpopup=1';
    $('#searchPersons',parent.document)[0].src='personDetail/?modalpopup=1';
    $('#searchPersons',parent.document)[0].width = "1050";
    $('#searchPersons',parent.document)[0].height = "400";
    $('.modal-content',parent.document)[0].style="min-width:1100px";
  }


  doSearch(name)
  {
    this.spinnerService.show();
    const normalizedName = (name || '').toString().replace(',', '').trim();
    const isNumber = normalizedName !== '' && !Number.isNaN(Number(normalizedName));
    if (isNumber) {
      this.ldapService.queryByGMIN(name).subscribe(res => {
        this.items.push(res.body);
        this.cdr.detectChanges();
      },
        error =>{console.log("LDAP search by GMIN API return error : " + error.toString()); this.spinnerService.hide();},
        () =>{this.LDAPSearchDone=true;}
      );
    }
    else{
      this.ldapService.queryByName(name).subscribe(res => {
        this.items=res.body;
        this.cdr.detectChanges();
      },
        error =>{console.log("LDAP search by Name return error : " + error.toString()); this.spinnerService.hide();},
        () =>{this.LDAPSearchDone=true;}
      );
    }
  }


  reloadExistingItems(params,name? : string) {
    //this.loading = true;
    if (this.searchFor.length>0)
      name=this.searchFor;
    if (name == undefined || name.length == 0) {
    }
    else {
      //setTimeout(()=>{this.doSearchExisting(params,name);},7000);
        this.doSearchExisting(params,name);
    }

    //this.localParams = params;
  }


  doSearchExisting(params,name)
  {
    //this.loading = true;
    if (!this.LDAPSearchDone) {
      setTimeout(()=>{this.doSearchExisting(params,name);},100);
    }
    else {
      if (this.needFullPage) {
        this.remoteService.queryByNames(name, params).subscribe(res => {
            this.exitingItems = res.body.content;
            this.itemCount = Number(res.body.totalElements); //Number(res.headers.get('X-Total-Count'));
            this.cdr.detectChanges();
            for (let i = 0; i < this.exitingItems.length; i++) {
              let indx = this.items.findIndex(x => x.identificationId == this.exitingItems[i].identificationId);
              if (indx != -1) {
                let obj = document.getElementsByClassName('data-column column-identificationId')[indx];
                if (obj) {
                  obj.setAttribute('style', 'background-color: rgb(122,255,255)');
                  obj.parentElement.getElementsByClassName('btn btn-secondary EditButton')[0].setAttribute('disabled', 'disabled');
                }
              }
            }

          },
          error => {
            console.log("loading existing drivers API return error : " + error.toString());
            this.spinnerService.hide();
          },
          () => {
            this.spinnerService.hide();
          }
        );
      }
      else{
        // for modal popup search
        this.remoteService.queryByNamesToPersons(name,params).subscribe(res=>{
          this.exitingItems = res.body.content;
          this.itemCount = Number(res.body.totalElements); //Number(res.headers.get('X-Total-Count'));
          this.cdr.detectChanges();
          for (let i = 0; i < this.exitingItems.length; i++) {
            let indx = this.items.findIndex(x => x.identificationId == this.exitingItems[i].identificationId);
            if (indx != -1) {
              let obj = document.getElementsByClassName('data-column column-identificationId')[indx];
              if (obj) {
                obj.setAttribute('style', 'background-color: rgb(122,255,255)');
                obj.parentElement.getElementsByClassName('btn btn-secondary EditButton')[0].setAttribute('disabled', 'disabled');
              }
            }
          }
        },
          error => {
            console.log("loading existing drivers API return error : " + error.toString());
            this.spinnerService.hide();
          },
          () => {
            this.spinnerService.hide();
          }
        );
      }
    }
  }

  // arrayDiff(arr2) {
  //   var ret = [];
  //   for(var i in this) {
  //     if(arr2.indexOf(this[i]) > -1){
  //       ret.push(this[i]);
  //     }
  //   }
  //   return ret;
  // };

  // special properties:

  rowClick(rowEvent) {
    console.log('Clicked: ' + rowEvent);
    //window.location.href="driverDetail/"+ rowEvent.row.item.gmInfo;
    //this.router.navigateByUrl('driverDetail/' + rowEvent.row.item.gmInfo);
  }
  EditClick(item){
    window.location.href='#/driverDetail/'+ item.driverID
  }
  SelectPerson(item){
    $('button.closeModal',parent.document).attr("personid",item.personID);
    $('button.closeModal',parent.document).click();
  }

  AddClick(item){
    this.spinnerService.show();
    console.log('Cell Add Clicked: ' + item.identificationId);
    var checkbox = $('#isCertifiedDriver'+item.identificationId)[0];
    if ((checkbox && <HTMLInputElement>checkbox.checked) || this.needFullPage)
    {
      // it is a modal pop up, and this checkbox checked, user like to add it to driver table
      let driver : Driver = new Driver();
      driver.driverID = item.driverID;
      driver.status_id = item.status_id;
      driver.lastUpdatedDate = item.lastUpdatedDate;
      driver.badgeID = item.badgeID;
      driver.department = item.department;
      driver.company = item.company;
      driver.ratingScore = item.ratingScore;
      driver.comment = item.comment;
      driver.gmPersonID = item.gmPersonID;
      driver.employeeTypeId = item.employeeTypeId;
      driver.namePrefix = item.namePrefix;
      driver.identificationId = item.identificationId;
      driver.personID = item.personID;
      driver.firstName = item.firstName;
      driver.middleName = item.middleName;
      driver.lastName = item.lastName;
      driver.email = item.email;
      driver.phoneNumber= item.phoneNumber;
      driver.preferredName = item.preferredName;

      this.driverService.AddDriverInfo(driver).subscribe(value => {
          console.log(value + " saved.");
          if(this.needFullPage)
            window.location.href="#/driverDetail/"+ value.driverID;
          else
            this.SelectPerson(value);
        }, (error) => {
          //failed
          console.error(error);
          alert('Adding new Driver return Error : <br/>'+ error);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        });
    }
    else if (checkbox && !<HTMLInputElement>checkbox.checked && !this.needFullPage){
      let gmPerson: GmPerson = new GmPerson();
      gmPerson.badgeID= item.badgeID;
      gmPerson.identificationId = item.identificationId;
      gmPerson.employeeTypeId = item.employeeTypeId;
      gmPerson.department = item.department;
      gmPerson.company = item.company;
      gmPerson.namePrefix = item.namePrefix;
      gmPerson.firstName = item.firstName;
      gmPerson.middleName = item.middleName;
      gmPerson.lastName = item.lastName;
      gmPerson.email = item.email;
      gmPerson.phoneNumber= item.phoneNumber;
      gmPerson.preferredName = item.preferredName;

      this.gmPersonService.addGMPerson(gmPerson).subscribe(value => {
          console.log(value + " saved.");
          this.SelectPerson(value);
        }, (error) => {
          //failed
          console.error(error);
          alert('Adding new Driver return Error : <br/>'+ error);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        });
    }

  }


  rowTooltip(item) { return item.lastName + ', ' + item.firstName; }
}
